import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { mathematicsData } from '../../data/departmentalData/mathematics';

const Mathematics = () => {
  return <TemplatePage data={mathematicsData} />;
};

export default Mathematics;
